import React, { Component, Fragment, createRef } from "react";
import { Multiselect } from 'multiselect-react-dropdown';
import AppContext from "../../contexts/AppContext";
import StepsHeader from "./include/StepsHeader";
import CheckoutSteps from "./include/CheckoutSteps";
import { checkToken, updateUserWithToken } from "../../services/user";


export class SelectInterest extends Component {	
	
	constructor(){
        super();
        this.state = {
			loading: false,
			interests: [],
			whyProwriter: [],
			item: {},	
			items: {
				user_industries: null,
				whyPW: null,
				category_id: '',
				freelancing_experience: null,				
				step: 'interest',				
				token_type: 'pwonbs1'
			},
			interest : "0",
			reason : "0",
			freelance : "0",
			rowsToDisplay : 8,
			expanded: false,
			industry : [],
			whyPWReason: [],
			freelancingExperienceList: [],
			roles: [],
			errors: {},			
        }

		this.handleInterests = this.handleInterests.bind(this);
		this.handleWhyPW = this.handleWhyPW.bind(this);
		this.showMore = this.showMore.bind(this);
    }

	showMore = () => {
		this.state.rowsToDisplay === 8 ? (
		  this.setState({ rowsToDisplay: this.state.industry.length, expanded: true })
		) : (
		  this.setState({ rowsToDisplay: 8, expanded: false })
		)
	}
    	
	checkInterest = Id => {
		this.setState({ interest: this.state.interest === Id ? "0" : Id });
    };
	
	whatBrings = Id => {
		this.setState({ reason: this.state.reason === Id ? "0" : Id});
	}

	freelanceExp = Id => {
		this.setState({ freelance: this.state.freelance === Id ? "0" : Id});
	}

	handleInterests = (e) => {
		// current array of options
		const options = this.state.interests
		let index
		
		
		if (options.length < 5) {
			if (e.target.checked) {
				options.push(+e.target.value)
			} else {
				index = options.indexOf(+e.target.value)
				options.splice(index, 1)
			}
		} else { 
			if (options.length >= 5) {
				if (e.target.checked) {
					e.target.checked = false;
					e.preventDefault();
					this.context.state.showCodeMessage('You can not select more than 5 interests', 'error')
				} else {
					index = options.indexOf(+e.target.value)
					options.splice(index, 1)
				}
			}
		}



		
		let temp = this.state.items;
		temp['user_industries'] = (options.length > 0 && options.length <= 5) ? options.join(',') : null;
		// update the state with the new array of options
		this.setState({ interests: options, items: temp })		
		//console.log(this.state.interests);
	}



	handleWhyPW = (e) => {
		// current array of options
		const options = this.state.whyProwriter
		let index
	
		// check if the check box is checked or unchecked
		if (e.target.checked) {
		  // add the numerical value of the checkbox to options array
		  options.push(+e.target.value)
		} else {
		  // or remove the value from the unchecked checkbox from the array
		  index = options.indexOf(+e.target.value)
		  options.splice(index, 1)
		}
		let temp = this.state.items;
        temp['whyPW'] = options.length > 0 ? options.join(',') : null;
		// update the state with the new array of options
		this.setState({ whyProwriter: options, items: temp })		
		
	}
	
	handleSubmit = e => {
		e.preventDefault();
		this.setState({ loading: true });
        updateUserWithToken(this.state.items, this.props.match.params["token"])
            .then(res => {
				this.setState({loading: false}); 
				//this.context.state.showCodeMessage(res.message,'success'); 
                if (res.meta.token) {
					this.props.history.push('/process/preference/' + res.meta.token);                    
                }
            })
            .catch(error => {
				this.setState({loading: false}); 				
                this.context.state.handelError(error);
            });    
	}; 

	onChange = field => {
        let temp = this.state.items;
        temp[field.target.name] = field.target.value;

        let error = this.state.errors;
        error[field.target.name] = null;

        this.setState({ items: temp, errors: error });
    };
	
	onSelect = (selectedList, selectedItem) => {
        let result = selectedList.map(a => a.value);
        let temp = this.state.item;
        temp['category_id'] = result.length > 0 ? result.join(',') : null;

        let error = this.state.errors;
        error['category_id'] = null;
        this.setState({ item: temp, errors: error });      
    }
    
    onRemove = (selectedList, selectedItem) => {
        let result = selectedList.map(a => a.value);
        let temp = this.state.item;
        temp['category_id'] = result.length > 0 ? result.join(',') : null;

        let error = this.state.errors;
        error['category_id'] = null;
        this.setState({ item: temp, errors: error });       
    }

	componentDidMount() {
        checkToken({ token: this.props.match.params["token"], type: 'pwonbs1' })
            .then(res => {
                if (res.status === true) {
                    this.setState({
                        item: res.data,  
						industry: res.meta.industries,
						whyPWReason: res.meta.whyPw,
						roles: res.meta.categories,
						freelancingExperienceList: res.meta.freelanceWritingExperience,                     
                    });                    
                } else {
                    this.setState({ validToken: false });
                }
            })
            .catch(error => {
                this.setState({ validToken: false });
            });
	};
	
	back = () => {
		this.props.history.push('/process/personal-details/' + this.props.match.params["token"]); 
	}	
	
    render() {
		const { roles } = this.state;
		return (
            <Fragment>
                <div className="account-wrapper">
				    <StepsHeader></StepsHeader>
                    <section className="checkout pb-5">
				        <div className="container position-relative">				    	    
				    	    <CheckoutSteps onboardStep="[1,2,3]" show="3"></CheckoutSteps>
                            <div className="create-profile mx-auto mb-3">							
							    <h3 className="mb-2 text-md-center">Select your interests</h3>
                                <p className="mb-5 text-md-center text-dark">We'll help you find and land writing gigs in your interests.<br className="d-md-inline-block d-none"/>Choose up to 5 interests:</p>								
								<div className="row mb-5 pb-md-5 pb-4">
								{this.state.industry.slice(0,this.state.rowsToDisplay).map((item, i) => 
								    <div key={i} className={ this.context.state.inArray(item.id,this.state.interests) ? "col-lg-3 col-md-4 col-sm-6 mb-4 interest-block active" : "col-lg-3 col-md-4 col-sm-6 mb-4 interest-block"}>
									    <div className="position-relative custom-control custom-checkbox py-5">
											<input type="checkbox" onChange={this.handleInterests} className="custom-control-input" name="interest" id={`customCheck${item.id}`} value={item.id}/>
											<label className="custom-control-label d-block" htmlFor={`customCheck${item.id}`}>
												<div className="img-container mb-5">
													<img className="d-block mx-auto" src={item.icon_image} loading="lazy" alt={item.name} title={item.name}/>
												</div>												
												<p className="mt-3 text-center">{item.name}</p>
											</label>
										</div>
								    </div>
									)}
									{
										this.state.industry.length > 8 ? 
											<div className="col-12">
												<button type="button" className={`btn continue btn-primary ${this.state.expanded ? `grey` : ``} border-0 d-block mx-auto`} onClick={this.showMore}>Show {this.state.expanded ? `less` : `more`}</button>
											</div> 
										: null
									}
								    
								</div>
								{/* <h3 className="mb-4 text-md-center">Select Role</h3>
                                <div className="row reasons justify-content-center mb-4">
								    <div className="col-lg-6 col-md-10">
									    <Multiselect options={roles} onSelect={this.onSelect} onRemove={this.onRemove} displayValue="label" selectionLimit="4" placeholder="Roles" />
									</div>
								</div> */}
								<h3 className="pt-md-5 pt-4 my-5 text-md-center">What brings you to ProWriter?</h3>
								<div className="row reasons flex-column align-items-center">
									{this.state.whyPWReason.map((v, i) => 
										<div className="col-12 text-center mb-4" key={i}>
											<div className={this.state.reason === v.id ? "border py-3 pr-4 pl-3 d-inline-block active" : "border py-3 pr-4 pl-3 d-inline-block"}>
												<div className="position-relative custom-control custom-radio">
													<input type="radio" onChange={this.onChange} className="custom-control-input" name="whyPW" id={v.id} value={v.id}/>
													<label onClick={() => this.whatBrings(v.id)} className="custom-control-label" htmlFor={v.id}>
														{v.name}
													</label>
												</div>
											</div>
										</div>
									)}									
								</div>
								<h3 className="pt-md-5 pt-4 my-5 text-md-center">What is your freelance writing experience?</h3>
								<div className="row reasons flex-column align-items-center">
									{this.state.freelancingExperienceList.map((v, i) => 
										<div className="col-12 text-center mb-4" key={i}>
											<div className={`border py-3 pr-4 pl-3 d-inline-block ${this.state.freelance === v.id ? `active` : ``}`}>
												<div className="position-relative custom-control custom-radio">
													<input type="radio" onChange={this.onChange} className="custom-control-input" name="freelancing_experience" id={`free${v.id}`} value={v.id}/>
													<label onClick={() => this.freelanceExp(v.id)} className="custom-control-label" htmlFor={`free${v.id}`}>
														{v.name}
													</label>
												</div>
											</div>
										</div>
									)}									
								</div>
							</div>
				    	    <hr className="my-5"/>
							<div className="d-flex align-items-center justify-content-between flex-md-row flex-column px-3">
                                <button type="button" onClick={() => this.back()} className="btn back btn-primary border-0">Back</button>								
							    <button type="button" onClick={this.handleSubmit} disabled={this.state.loading} className="btn continue btn-primary border-0 mb-md-0 mb-3"><i className={this.state.loading ? `mr-2 fas fa-spinner fa-spin` : null}></i> {this.state.loading ? `Processing...` : `Continue`}</button>								
							</div>
						</div>		
				    </section>
				</div>	
            </Fragment>
        );
    }
}

SelectInterest.contextType = AppContext;
export default SelectInterest;



// WEBPACK FOOTER //
// ./src/components/general/SelectInterest.js